import React, { useContext } from 'react'
import cn from 'classnames'
import { FixedSpacer } from '@grammarly/badger-ui'

import { PageSwoosh, TypeItemFeatureHighlight } from '../../../lib/types'
import { SectionContext } from '../../../contexts/section-context'
import { SectionThemeContext } from '../../../contexts/section-theme-context'
import { getSwooshStyle } from '../../swoosh'
import { containedImageStyle } from '../../ui-lib/image'
import { useBackgroundStyle } from '../../page-section/theme'
import { FeatureHighlightProvider } from '../../../contexts/feature-highlight-context'
import { SingleColumnLayout } from '../../layout/single-column'
import { FeatureHighlight } from '../../item/feature-highlight'
import { Background } from '../../../lib/types/background'
import { TypeAlignment } from '../../../lib/types/alignment'

interface TabSectionProps {
  className?: string
  background?: Background
  heading?: TypeItemFeatureHighlight
  alignment?: TypeAlignment
  children: React.ReactNode
}

export const GroupTabSection: React.FC<TabSectionProps & { sectionGroupSwoosh?: PageSwoosh }> = ({
  className,
  children,
  background,
  heading,
  sectionGroupSwoosh,
}) => {
  const { isH1Section } = useContext(SectionContext)
  const theme = useContext(SectionThemeContext)
  const backgroundStyle = useBackgroundStyle(theme, background?.color)

  const { className: swooshClassName, backgroundImage } = getSwooshStyle(sectionGroupSwoosh)

  return (
    <div className={cn(containedImageStyle, ...backgroundStyle, className)}>
      <div className={cn(swooshClassName)} style={{ backgroundImage }}>
        {heading && (
          <FeatureHighlightProvider value={{ titleStyle: 'T1' }}>
            <SingleColumnLayout>
              <FeatureHighlight structure={heading} titleTag={isH1Section ? 'h1' : 'h2'} />
              <FixedSpacer multiplier={7} />
            </SingleColumnLayout>
          </FeatureHighlightProvider>
        )}
        {children}
      </div>
    </div>
  )
}
